import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Wrapper, Container } from '../../../components_renew/Layout'
// import { IntegralHeader } from '../../../components_renew/Integral/IntegralHeader'
import IntegralCard from '../IntegralCard'
import IntegralCardV2 from '../IntegralCardV2'
// import IntegralInlineBlock from '../IntegralInlineBlock'
// import IntegralBar from '../IntegralBar'
import IntegralList from './IntegralList'
// import IntegralGrid from '../IntegralGrid'
import { requestIntegralData } from '../../../actions/integralAction'
import { withTranslation } from 'react-i18next'
// import { componentUpdateWithToast } from '../../../components_renew/HOC'
/*
2025/05/16
这一块v3暂时是trading的定制页，去除某些模块
 */
// let flag = false
// let clickFlag = false
let RenderCard = IntegralCard
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    // flag = true
    // clickFlag = true
    break
  // case 'xibei':
  // case 'xiniu':
  // case 'tradeasy':
  //   break
  default:
    // flag = process.env['REACT_APP_BUILD_ENV'] === 'development'
    RenderCard = IntegralCardV2
}

class IntegralTitle extends React.PureComponent {
  static defaultProps = {
    extend: '',
    onExtendClick: function () {}
  }

  render () {
    return <div className='integral-title'>
      <div className='integral-title__main'>{this.props.children}</div>
      <div className='integral-title__extend' onClick={this.props.onExtendClick}>{this.props.extend}</div>
    </div>
  }
}

@withTranslation()
@connect(state => {
  const { loading, errorMessage } = state.common
  return { loading, errorMessage }
})
@withRouter
// @componentUpdateWithToast
class IntegralHome extends React.PureComponent {
  componentDidMount () {
    this.props.dispatch(requestIntegralData())
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const {errorMessage} = this.props
    const {preErrorMessage} = prevProps
    if(errorMessage && preErrorMessage !== errorMessage) {
      window.toast.fail(errorMessage)
    }
  }

  render () {
    const { t } = this.props
    return <Container>
      {/*<IntegralHeader>{t('integral.title')}</IntegralHeader>*/}
      <Wrapper>
        <RenderCard/>
        <div className={'integral-wrapper'}>
          {/* 2025/05/16 由于无翻译去掉以下这一块*/}
          {/*{process.env['REACT_APP_CHANNEL'] === 'haiou'*/}
          {/*  ? <>*/}
          {/*    <IntegralTitle>{t('integral.block_title_1')}</IntegralTitle>*/}
          {/*    <IntegralInlineBlock eventOpenFlag={!clickFlag}/>*/}
          {/*  </>*/}
          {/*  : <IntegralGrid/>*/}
          {/*}*/}
          {/*2021/09/09 暂时关闭赚积分入口*/}
          {/*<IntegralTitle>如何赚积分</IntegralTitle>*/}
          {/*<IntegralBar />*/}
          <IntegralTitle extend={`${t('integral.block_title_3_sub')} >`} onExtendClick={this.goToDetails}>{t('integral.block_title_3')}</IntegralTitle>
          <IntegralList/>
        </div>
      </Wrapper>
    </Container>
  }

  goToDetails = () => {
    this.props.history.push(window.PATH.INTEGRAL_DETAILS+'?tab=i-0')
  }

}

export default IntegralHome
